"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.secondaryButtons = void 0;
exports.secondaryButtons = [
    {
        props: { variant: 'secondaryDefault' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                color: theme.palette.text.interactive,
                border: "1px solid ".concat(theme.palette.secondary.main),
                '&:hover': {
                    color: theme.palette.text.interactive,
                    backgroundColor: theme.palette.secondary.light,
                    border: "1px solid ".concat(theme.palette.secondary.main),
                },
                '&:active': {
                    color: theme.palette.text.light,
                    backgroundColor: theme.palette.secondary.dark,
                    border: "1px solid ".concat(theme.palette.secondary.dark),
                },
                '&:disabled': {
                    backgroundColor: theme.palette.neutrals.white,
                    color: theme.palette.text.disabled,
                    border: "1px solid ".concat(theme.palette.text.disabled),
                },
            });
        },
    },
    {
        props: { variant: 'secondaryHC' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                color: theme.palette.text.light,
                border: "1px solid ".concat(theme.palette.neutrals.white),
                '&:hover': {
                    color: theme.palette.text.interactive,
                    backgroundColor: theme.palette.secondary.light,
                    border: "1px solid ".concat(theme.palette.neutrals.white),
                },
                '&:active': {
                    color: theme.palette.text.interactive,
                    backgroundColor: theme.palette.neutrals.primary,
                    border: "1px solid ".concat(theme.palette.neutrals.white),
                },
                '&:disabled': {
                    backgroundColor: theme.palette.backgrounds.dark,
                    color: theme.palette.text.disabled,
                    border: "1px solid ".concat(theme.palette.text.disabled),
                },
            });
        },
    },
];
